module.exports = __webpack_public_path__ + "img/customer12.a80a3725.png";